import { io } from "socket.io-client";
import { apiRequest, SOCKET_URL } from "./apiClient";

const unwrapData = (response) => response?.data ?? response ?? [];

export const fetchConversations = async () => {
  const response = await apiRequest("/chat/conversations");

  return unwrapData(response);
};

export const fetchMessages = async (conversationId) => {
  const response = await apiRequest(`/chat/messages/${conversationId}`);

  return unwrapData(response);
};

export const assignAdmin = async ({ conversationId, adminId }) => {
  return apiRequest("/chat/assign", {
    method: "POST",
    toast: false,
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      conversation_id: conversationId,
      ...(adminId ? { admin_id: adminId } : {}),
    }),
  });
};

export const connectChatSocket = (token) => {
  return io(SOCKET_URL, {
    auth: {
      token,
    },
  });
};

export const joinConversation = (socket, conversationId) => {
  if (!socket || conversationId == null) return;

  socket.emit("join_conversation", conversationId);
};

export const sendMessage = (socket, conversationId, message) => {
  return new Promise((resolve, reject) => {
    if (!socket) {
      return reject(new Error("Socket is not connected."));
    }

    socket.emit(
      "send_message",
      {
        conversation_id: conversationId,
        message,
      },
      (response) => {
        if (!response) {
          return reject(new Error("No response received for sent message."));
        }

        const payload = response?.data ?? response;

        if (payload.error || payload.status === "error") {
          return reject(
            new Error(
              payload.error || payload.message || "Unable to send message.",
            ),
          );
        }

        resolve(payload);
      },
    );
  });
};

export const normalizeSocketMessage = (message) => {
  const createdAt =
    message.created_at ||
    message.createdAt ||
    message.timestamp ||
    message.sent_at ||
    new Date().toISOString();

  return {
    id: message.id || message._id,
    conversationId: message.conversation_id || message.conversationId,
    senderId: message.sender_id || message.senderId,
    message:
      message.message || message.body || message.text || message.content || "",
    messageType: message.message_type || message.messageType,
    status: message.status || message.state,
    createdAt,
  };
};

export const normalizePresencePayload = (payload = {}, fallbackOnline) => {
  const user = payload.user || payload.customer || {};
  const customer = payload.customer || payload.user || {};
  const status =
    payload.status ||
    payload.presence ||
    payload.connectionStatus ||
    user.status ||
    user.presence ||
    user.connectionStatus ||
    customer.status ||
    customer.presence ||
    customer.connectionStatus;
  const userId =
    payload.userId ||
    payload.user_id ||
    payload.id ||
    payload.sender_id ||
    payload.senderId ||
    user.id ||
    user.userId ||
    user.user_id ||
    customer.id ||
    customer.userId ||
    customer.user_id;
  const onlineValue = [
    payload.isOnline,
    payload.is_online,
    payload.online,
    user.isOnline,
    user.is_online,
    user.online,
    customer.isOnline,
    customer.is_online,
    customer.online,
  ].find((value) => typeof value === "boolean");
  const isOnline =
    typeof onlineValue === "boolean"
      ? onlineValue
      : typeof status === "string"
        ? status.toLowerCase() === "online"
        : fallbackOnline;

  return {
    userId,
    isOnline,
    lastSeenAt:
      payload.lastSeenAt ||
      payload.last_seen_at ||
      payload.updated_at ||
      user.lastSeenAt ||
      user.last_seen_at ||
      customer.lastSeenAt ||
      customer.last_seen_at,
  };
};
